import type { FC } from 'react';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import type { IToolbarItem } from 'ricos-types';
import { EditIcon, ToggleButton } from 'wix-rich-content-toolbars-ui';

interface Props {
  toolbarItem: IToolbarItem;
  dataHook?: string;
}

const ImageEditorButton: FC<Props> = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};

  const onClick = toolbarItem.commands.click;

  const node = (toolbarItem.attributes as Record<string, any>).selectedNode;

  const src = node?.attrs.image?.src?.id;

  return (
    <ToggleButton
      Icon={EditIcon}
      onClick={() => onClick({ src })}
      dataHook={dataHook}
      tooltip={t('ImageEditorButton_Tooltip')}
      disabled={!src}
    />
  );
};

export default ImageEditorButton;
